module.exports = __webpack_public_path__ + "img/determinacion.3b9fc509.png";